module.exports = __webpack_public_path__ + "fonts/store_download_button.svg";